import { render, staticRenderFns } from "./MoveMember.vue?vue&type=template&id=df6cf0ac&"
import script from "./MoveMember.vue?vue&type=script&lang=js&"
export * from "./MoveMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports